const APPLICATION_VERSION = APP_VERSION;
export default APPLICATION_VERSION;
